import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Store from '@/store/'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: "Training and support 2017-2020"
    },
  },
  {
    path: '/code',
    name: 'Code',
    meta: {
      title: "Training and support 2017-2020"
    },
    component: () => import(/* webpackChunkName: "code" */ '../views/Code.vue'),
  },
  {
    path: '/reader',
    name: 'Reader',
    meta: {
      title: "QR Reader"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "reader" */ '../views/Reader.vue')
  },
  {
    path: '/quick-event',
    name: 'QuickEvent',
    meta: {
      title: "Quick Event"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "quickevent" */ '../views/QuickEvent.vue')
  },
  {
    path: '/search-results/',
    name: 'SearchResult',
    meta: {
      title: "Search Results"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "SearchResult" */ '../views/SearchResult.vue')
  },
  {
    path: '/trainee/scenario/:scenarioId',
    name: 'Scenario',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "traineeScenario" */ '../views/trainee/Scenario.vue')
  },
  {
    path: '/trainee/scenario/:scenarioId/playlist/:playlistId',
    name: 'ScenarioPlaylist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "traineeScenario" */ '../views/trainee/Scenario.vue'),
    // props: (route) => ({ query: route.query.d })
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log("to", to)

  if ( to.meta.title ) {
    Store.dispatch('setHeaderTitle', to.meta.title)
  }

  // We zetten de index als als dat nodig is
  if ( to.query.d ) {
    // console.log('setting index ', to.query.d )
    Store.dispatch('traineeStatusModule/setDecisionIndex', parseInt(to.query.d) )
  } else {
    Store.dispatch('traineeStatusModule/setDecisionIndex', 0)
  }

  if ( to.params.scenarioId ) {
    Store.dispatch('setHeaderType', 'ScenarioHeader')
  } else {
    Store.dispatch('setHeaderType', 'PageHeader')
  }

  // Set scanned so we know this is a QR coded session
  if ( to.query.scanned == "1") {
    Store.dispatch('setScanned', true)
  }
  next()
})

export default router
